import axios from 'axios';
import {buildQuery} from 'utils/QueryUtils';

export const findOrders = (headers, params) => {
  let query = buildQuery(params);
  return axios.get(`${process.env.REACT_APP_INFO_API_URL}/orders${query}`, {
    headers,
  });
};

export const findOrderById = (headers, id) => {
  return axios.get(`${process.env.REACT_APP_INFO_API_URL}/orders/${id}`, {
    headers,
  });
};

export const updateOrder = (headers, id, data) => {
  return axios.patch(
    `${process.env.REACT_APP_INFO_API_URL}/orders/${id}`,
    data,
    {
      headers,
    },
  );
};

export const deleteOrder = (headers, id) => {
  return axios.delete(`${process.env.REACT_APP_INFO_API_URL}/orders/${id}`, {
    headers: headers,
  });
};
